import { css } from "styled-components";

const ptSerif_heading_base = css`
  font-family: var(--font-pt-serif);
  font-style: normal;
  font-weight: var(--text-weight-bold);
  letter-spacing: 0;
`;

export const ptSerif_heading_xl = css`
  ${ptSerif_heading_base};
  font-size: var(--text-heading-size-xl);
  line-height: 3.12rem;
`;

export const ptSerif_heading_lg = css`
  ${ptSerif_heading_base};
  font-size: var(--text-heading-size-lg);
  line-height: 2.6rem;
`;

export const ptSerif_heading_md = css`
  ${ptSerif_heading_base};
  font-size: var(--text-heading-size-md);
  line-height: 2.34rem;
`;

export const ptSerif_heading_sm = css`
  ${ptSerif_heading_base};
  font-size: var(--text-heading-size-sm);
  line-height: 2.08rem;
`;
